// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/css/style.less
// module id = ./assets/css/style.less
// module chunks = 0